import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'
import { API_ROUTES } from '../../../utility/api.routes'
import { convertDate, formatDateToUTC } from '../../../utility/genricFunction'
import { setexamAssessPageData } from '../../slice/exam-assessment/examassessment.slice';

const constructQueryParams = (filters) => {
  const params = new URLSearchParams();
  Object.keys(filters).forEach((key) => {
      if (filters[key].value !== null && filters[key].value !== undefined && filters[key].value !== '') {
          params.append(key, key == 'date' ? filters[key].value !==null && convertDate(filters[key].value) : filters[key].value);
      }
  });
  return params.toString();
};

export const getAllExam = createAsyncThunk('allexam/getAllExam', async ({facultyId,filters},{dispatch}) => {
    try {
      const queryParams = constructQueryParams(filters);
      const url = `${API_ROUTES.EXAM.GET_EXAM(facultyId)}?${queryParams}`
      const response = await apiClient.get(url)
      response?.data?.result?.exams.forEach(result => {
        const date = result.date !== null && new Date(result.date);
        result.date = result.date !== null && formatDateToUTC(date)
      }); 
      dispatch(setexamAssessPageData(response?.data?.result))
      return response?.data?.result?.exams
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  })
